import { Box3, Vector3 } from 'three';
import { animateCameraTo } from './cameraTransition';

export function flattenCatalogueLayers(modelList) {
  const items = [];
  (modelList || []).forEach((section) => {
    (section.models || []).forEach((model) => {
      const label = model.displayName || model.label || model.name;
      items.push({
        id: model.name,
        label: String(label || model.name),
        group: section.group,
        category: section.name,
        layerKey: model.name,
        kind: 'layer',
      });
    });
  });
  return items;
}

export function searchCatalogue(modelList, query, limit = 12) {
  const q = String(query || '').trim().toLowerCase();
  if (q.length < 1) return [];
  const scored = [];
  flattenCatalogueLayers(modelList).forEach((item) => {
    const hay = `${item.label} ${item.layerKey} ${item.group || ''} ${item.category || ''}`.toLowerCase();
    const idx = hay.indexOf(q);
    if (idx < 0) return;
    scored.push({ ...item, score: idx === 0 ? 0 : idx });
  });
  scored.sort((a, b) => a.score - b.score || a.label.localeCompare(b.label));
  return scored.slice(0, limit);
}

export function findObjectByLayerKey(scene, layerKey) {
  if (!scene || !layerKey) return null;
  let found = null;
  scene.traverse((obj) => {
    if (found) return;
    if (obj.userData?.mdvLayerKey === layerKey) found = obj;
  });
  return found;
}

export function flyToObject(camera, controls, object) {
  if (!camera || !object) return false;
  const box = new Box3().setFromObject(object);
  const center = new Vector3();
  box.getCenter(center);
  if (!Number.isFinite(center.x)) return false;
  const size = box.getSize(new Vector3()).length();
  const dist = Math.max(size * 1.5, 80);
  const dir = camera.position.clone().sub(controls?.target || center);
  if (dir.lengthSq() < 1e-6) dir.set(1, 0.45, 1);
  dir.normalize();
  const position = center.clone().add(dir.multiplyScalar(dist));
  animateCameraTo({
    camera,
    controls,
    position,
    target: center,
  });
  return true;
}

export function sleep(ms) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

export async function flyToLayer({ scene, camera, controls, layerKey, timeoutMs = 8000 }) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const obj = findObjectByLayerKey(scene, layerKey);
    if (obj && flyToObject(camera, controls, obj)) return true;
    await sleep(180);
  }
  return false;
}
